import React, { FC } from "react";
import { Sticky } from "react-sticky";
import "./PageNav.style.css";

export const PageNav: FC = (props) => {
  return (
    <Sticky>
      {({ style }) => (
        <div className="pagenav-container" style={style}>
          Top Nav
        </div>
      )}
    </Sticky>
  );
};
